import { SkeletonTable } from './SkeletonTable';

export function SkeletonPage() {
  return (
    <div className="space-y-6">
      {/* Page header */}
      <div className="flex items-center justify-between">
        <div className="skeleton-shimmer h-7 w-48 rounded" />
        <div className="skeleton-shimmer h-9 w-32 rounded-lg" />
      </div>
      {/* Search bar */}
      <div className="skeleton-shimmer h-10 w-full max-w-sm rounded-lg" />
      {/* Table */}
      <SkeletonTable rows={8} cols={5} />
      {/* Pagination */}
      <div className="flex items-center justify-between">
        <div className="skeleton-shimmer h-4 w-40 rounded" />
        <div className="flex gap-2">
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="skeleton-shimmer h-8 w-8 rounded" />
          ))}
        </div>
      </div>
    </div>
  );
}
